import { styled, $fontWeightBold } from "@acko-tech/building-blocks.ui.common";

export const ModalHeading = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: ${$fontWeightBold};
  line-height: 1.5rem;
  width: 100%;
`;
